<template>
  <form class="df fdc" @submit.prevent="register">
    <h2 class="nexa-font-bold ttc">Create your account</h2>
    <!-- <input v-model="fullName" class="input-landing" type="text" placeholder="Full Name"/> -->
    <input v-on:input="setLandingEmail()" v-model="email" class="input-landing input1 mb10" type="email" placeholder="Email Address"/>
    <span class="show-password-wrapper mb20">
      <input v-model="password" class="input-landing input1" placeholder="Password" v-bind:type="showPassword ? 'text' : 'password'"/>
      <p class="show-password" v-on:click="togglePassword()">{{ showPassword ? 'Hide' : 'Show' }}</p>
    </span>
    <button class="button-landing nexa-font-bold ls05" type="submit">Register</button>
    <p v-if="$store.getters.authError" class="login-register-error animated fadeIn">{{ $store.getters.authError }}</p>
    <p class="account-caption">Already have an account? <router-link :to="'/login'">Sign in</router-link></p>
  </form>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {
      email: '',
      password: '',
      fullName: 'My Name',
      showPassword: false
    }
  },
  props: ['landingEmail'],
  components: {

  },
  methods: {
    setLandingEmail () {
      this.$store.dispatch('clearAuthError', {})
      this.$emit('setLandingEmail', {landingEmail: this.email})
    },
    togglePassword () {
      this.showPassword = !this.showPassword
    },
    register () {
      if ((this.fullName.length > 64) || !/^[A-Za-z ]+$/.test(this.fullName)) {
        this.$store.dispatch('setAuthError', {
          message: 'Please enter a valid name'
        })
        return false
      }

      this.$store.dispatch('clearAuthError', {
      })
      this.$store.dispatch('register', {
        email: this.email,
        password: this.password,
        fullName: this.fullName,
        url: window.location.origin
      })
    }
  },
  computed: {

  },
  created () {
    this.landingEmail ? this.email = this.landingEmail : null
    this.$store.dispatch('clearAuthError', {})
  }
}
</script>

<style scoped lang="scss">
  h2 {
    color: black;
    font-weight: 500;
    margin-bottom: 30px;
    align-self: center;

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      font-size: 16px;
    }
  }

.show-password-wrapper {
  position: relative;
}

.show-password {
  position: absolute;
  right: 8px;
  top: 8px;
  color: #5558FF;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.21px;
  line-height: 14px;
  cursor: pointer;
  font-family: 'GG';
  font-weight: 400;
}
.account-caption {
  a {
    color: #5558FF;
    text-decoration: none;
    font-weight: 500;
    cursor: pointer;
    font-family: 'GG';
  }
}
</style>
